module.exports = __webpack_public_path__ + "media/images/features/support/thumb-type-tel-13346883a96f623e8d5d4ba9d03feadc.png";